import Image from "next/image";
import Layout from "../components/Layouts";
import Nav from "../components/Navi";
import Footer from "../components/Footers";
import CountdownBar from "../components/CountdownBar";
import SocialMedia from "../components/SocialMedia";
import ExploreMore from "../components/ExploreMore/hostCountryMedia";
import React from "react";
import styles from "../styles/host-country-media.module.scss";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import {registerRequest} from "@services/azure/authConfig";
import {useMsal} from "@azure/msal-react";
export default function hostCountryMedia() {
  const { t } = useTranslation("common");
  const { instance } = useMsal();
  const IMG_URI = 'https://sthayyacrossingstg01.blob.core.windows.net/hayyacrossing-web-assets/';

  const handleLogin = (loginType) => {
    if (loginType === "popup") {
      instance.loginPopup(registerRequest).catch((e) => {
        console.log(e);
      });
    } else if (loginType === "redirect") {
      instance.loginRedirect(registerRequest).catch((e) => {
        console.log(e);
      });
    }
  };

  return (
    <>
      <section className={`banner d-flex align-items-center position-relative`}>
        <div className={`${styles.bannerWrapper} d-none d-md-block`}>
          <Image
            src={IMG_URI + "hmp-banner2.png"}
            alt="host-country-media-img"
            layout="fill"
            objectFit="cover"
          />
        </div>
        <div className={`${styles.bannerWrapper} d-md-none`}>
          <Image
            src={IMG_URI + "hmp-banner2.png"}
            alt="home-img"
            layout="fill"
            objectFit="cover"
          />
        </div>
        <div className="container contentSection position-relative host-banner-text">
          <div className="col-lg-4 banner-content">
          <span className="text-white">{t("hostcountrymediapath")}</span>

            <h1 className="text-white banner-heading" >
              {t("hostcountrymediaTitle")}
            </h1>
          </div>
        </div>
      </section>
      <section className={`${styles.hostCountryMedia} py-5`}>
        {/* <div className="row"> */}
        <div className="row pt-sm-4-x remove_gutter-l">
          {/* <div className="row "> */}
            {/* <div className="col-md-7 text-burgundy ff-graphik pb-sm-4">
              <p>{t("hostcountrymediaText1")}</p>
              <p>{t("hostcountrymediaText2")}</p>
            </div> */}
            {/* <div className="col-md-5 d-flex justify-content-end mb-4 align-items-baseline">
              <img src="/assets/svg/goal.svg" alt="goal-svg" />
            </div> */}
          {/* </div> */}
         
          <div className="col-lg-6 col-12 mt-sm-5 p-5 ">
            <div className="px-lg-5">
            <h3 className="sect-heading">{t("aboutheadingtext")}</h3>
            <br/>
            <p className="">{t("hostcountrymediaText3")}</p>
            <p className="">
              {/* {t("while")} {t("while-link")} */}
              {t("hostcountrymediaText4")}
            </p>
            <button className="banner-btn mt-3" onClick={() => handleLogin('redirect')}>{t("applyAccreditationBtn")} </button>

            {/* <p className="ff-graphik">{t("hostcountrymediaText5")} </p> */}
            {/* <p className="ff-graphik">{t("hostcountrymediaText6")}</p> */}
          </div>
          </div>
          <div className="col-lg-6 col-12 m-auto">
            <div className="curvy-div mt-5"><img src={IMG_URI+"Group 65.png"} className="suit-img"/> </div>
          </div>
          {/* <div className="container-fluid">
            <div className={`${styles.images} py-4 row`}>
              <div className="col-sm-4 g-0 mb-sm-0 mb-3">
                <Image
                  src="/assets/images/fifaWorld.jpg"
                  alt="fifaWorld-img"
                  width={558}
                  height={373}
                  layout="responsive"
                  objectFit="cover"
                />
              </div>
              <div className="col-sm-4 g-0 mb-sm-0 mb-3">
                <Image
                  src="/assets/images/bus.jpg"
                  alt="bus-img"
                  width={558}
                  height={373}
                  layout="responsive"
                  objectFit="cover"
                />
              </div>
              <div className="col-sm-4 g-0 mb-sm-0 mb-3">
                <Image
                  src="/assets/images/cameraMan.jpg"
                  alt="cameraMan-img"
                  width={558}
                  height={373}
                  layout="responsive"
                  objectFit="cover"
                />
              </div>
            </div>
          </div> */}
          {/* <div className="d-flex justify-content-end px-sm-0 px-3">
            <img src="/assets/svg/bottomText.svg" alt="bottom-text" />
          </div> */}
        </div>
     
        {/* </div> */}
      </section>
      {/* <SocialMedia
        Color="#8a1538"
        colNumber="col-md-4 col-12"
        font="ff-qatar2022 fs-5"
        fontWeight="fw-medium"
        textColor="text-burgundy"
      /> */}
      {/* <CountdownBar />*/}
      <div className="sect-seperator my-0"><img src={IMG_URI+ 'hmp-star.png'}/></div>

      <ExploreMore /> 
    </>
  );
}

hostCountryMedia.getLayout = function getLayout(page) {
  return (
    <Layout>
      <Nav />
      {page}
      <Footer />
    </Layout>
  );
};

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}
